import type { FaireProductEntity } from "../../entity_types/product";

export const p_ntvymtr5tb: FaireProductEntity = {
  token: "p_ntvymtr5tb",
  type: "product",
  name: "Individually Packaged Shower Steamers",
  brandToken: "b_hunch3tcw6",
  brandName: "FD Market",
  imageUrl:
    "https://cdn.faire.com/fastly/8ae71f4245e21996303c402df8a824ef69f74146e08eb21bca1ff01a163da37d.png",
  galleryImageUrls: [],
  priceDollars: 1.75,
  description:
    "Transform your shower into a spa-like retreat with our natural shower steamers! Simply place a tab in your shower, away from the direct stream of water, and let it fizz to release an intense, therapeutic fragrance. Perfect for sinus relief or simply unwinding after a long day.\n\nPackaging and Freshness:\nOur shower steamers are packaged in compostable envelopes and sealed with a label. This helps for merchandising and is excellent for gifting!\n\nHandcrafted with Care:\nEach steamer is handmade with love in Emmaus, PA, using only the finest natural ingredients: sodium bicarbonate, citric acid, and essential oil blends.\n\nAromatherapy Blends:\nEucalyptus + Mint: Invigorating and sinus-clearing.\nLavender + Tea Tree: Relaxing and perfect for bedtime.\nCitrus + Mint: Energizing for mornings or midday boosts.\nBe Healthy (Cinnamon, Clove, Lemon, Rosemary, Eucalyptus): Immune-boosting, reminiscent of fall.\n\nElevate your daily routine with our natural shower steamers and enjoy a moment of tranquility.",
  tags: [],
  msrpDollars: 3.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:05.051Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
